import { render, staticRenderFns } from "./SectionLocalisationUrgence.vue?vue&type=template&id=973c46aa&scoped=true&"
import script from "./SectionLocalisationUrgence.vue?vue&type=script&lang=js&"
export * from "./SectionLocalisationUrgence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973c46aa",
  null
  
)

export default component.exports